<template>
  <div>
    <div-unit style="margin-top: 50px" unitTitle="Search for Protein">
      <div style="display: flex; flex-direction: column; margin-bottom: 50px">
        <div>
          <p style="font-weight: bold; margin-left: 92px; font-size: 22px">
            Input Protein Sequences (mandatory):
          </p>
          <p style="margin-left: 92px; font-size: 18px">
            Please copy and paste your protein sequence in FASTA format here
            &nbsp;&nbsp;&nbsp;
            <span
              class="input_example"
              @click="fastaExample('protein-example1')"
              ># Example</span
            >
          </p>
        </div>
        <div style="margin-left: 94px">
          <el-input
            type="textarea"
            v-model="seq_text"
            rows="6"
            style="width: 1020px; border-radius: 10px"
            class="protein-input"
          ></el-input>
        </div>
        <div>
          <p style="margin-left: 92px; font-size: 18px">
            Or upload the FASTA file (Please upload a <i>.fasta</i> or
            <i>.FASTA</i> file)
          </p>
        </div>
        <div style="margin-left: 94px">
          <el-upload
            class="upload-demo"
            style="margin-top: -20px"
            :action="upload_url"
            :on-exceed="handleExceed"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            :on-remove="handleRemove"
            :show-file-list="true"
            :limit="1"
            :file-list="fileList"
          >
            <el-button
              size="small"
              type="primary"
              class="btn-submit upload-btn"
              style="font-size: 18px"
              >Click Upload</el-button
            >
          </el-upload>
        </div>
        <div>
          <p style="margin: 5px 92px; font-size: 18px;color: gray">
            <i class="icon iconfont icon--idea" aria-hidden="true"></i>
            NOTE: A maximum of 50 protein sequences is permitted for
            submission. Protein sequences must be at least 40 amino acids in
            length to be valid for analysis. Additionally, each sequence should
            be preceded by a unique identifier, with each sequence entry
            separated by a new line starting with the '>' symbol.
          </p>
        </div>
        <!-- <div>
          <p
            style="
              font-weight: bold;
              margin-left: 92px;
              font-size: 22px;
              margin-top: 50px;
            "
          >
            Select Kingdom (mandatory):
          </p>
        </div>
        <div style="margin-left: 94px">
          <el-radio-group v-model="kingdom_str" size="medium">
            <el-radio-button label="Animalia"> Animalia </el-radio-button>
            <el-radio-button label="Plantae"> Plantae</el-radio-button>
            <el-radio-button label="Fungi"> Fungi</el-radio-button>
            <el-radio-button label="Unknow/Other">
              Unknow/Other</el-radio-button
            >
          </el-radio-group>
        </div> -->

        <div>
          <p
            style="
              font-weight: bold;
              margin-left: 92px;
              font-size: 22px;
              margin-top: 50px;
            "
          >
            Describe this mission (optional):
          </p>
          <!-- <p style="margin-left: 92px; font-size: 18px">
            <i class="icon iconfont icon--idea" aria-hidden="true"></i>
            &nbsp;&nbsp; Used to send the result
          </p> -->
        </div>
        <div style="margin-left: 94px">
          <el-input
            type="textarea"
            v-model="des_text"
            rows="2"
            style="width: 545px; border-radius: 10px"
            class="harding-font"
          ></el-input>
        </div>

        <div>
          <p
            style="
              font-weight: bold;
              margin-left: 92px;
              font-size: 22px;
              margin-top: 50px;
            "
          >
            Input Email Address (optional, used to send the result):
          </p>
        </div>
        <div style="margin-left: 94px">
          <el-input
            v-model="email_text"
            style="width: 545px; border-radius: 10px"
            class="protein-input"
          ></el-input>
        </div>

        <div
          style="display: flex; justify-content: space-evenly; margin-top: 20px"
        >
          <el-button
            class="btn-submit"
            @click="fastaReset()"
            style="font-size: 22px; width: 120px; border-radius: 10px"
            >Reset</el-button
          >
          <el-button
            class="btn-submit"
            @click="fastaSubmit()"
            style="font-size: 22px; width: 120px; border-radius: 10px"
            >Submit</el-button
          >
        </div>
      </div>
    </div-unit>
  </div>
</template>
    
    <script>
import DivUnit from "@/components/DivUnit.vue";
// import SearchProteinFullText from "@/components/searchBlock/SearchProteinFullText.vue";
import api from "@/api/index";
import pathUrl from "@/api/path";
export default {
  // name: "AdvancedAnalysis",
  data() {
    return {
      localUrl: pathUrl.localUrl,

      mission_id: "",

      des_text: "",
      seq_text: "",
      kingdom_str: "Unknow/Other",
      email_text: "",

      upload_url: pathUrl.baseUrl + "/the_biomarker/uploadFASTA",
      fileList: [],
      upload_str: "",
    };
  },
  props: {
    homeBlock: String,
  },
  components: {
    DivUnit,
    // SearchProteinFullText,
  },

  methods: {
    handleExceed() {
      this.$notify({
        title: "Warning",
        message: `Delete the old file before uploading the new file.`,
        type: "warning",
        duration: 10000,
      });
    },
    beforeUpload(file) {
      var isLt3M = Number(file.size / 1024 / 1024) > 5;
      var FileExt = file.name.replace(/.+\./, "");
      if (["fasta"].indexOf(FileExt.toLowerCase()) === -1) {
        this.$notify({
          title: "Warning",
          type: "warning",
          message: "Please upload the file with the suffix fasta",
          duration: 10000,
        });
        return false;
      }
      if (isLt3M) {
        this.$notify({
          title: "Warning",
          type: "warning",
          message: "The file size should not exceed 5MB",
          duration: 10000,
        });
        return false;
      }
    },
    uploadSuccess(response) {
      this.upload_str = response.random_str;
    },
    handleRemove() {
      this.upload_str = "";
    },

    fastaExample(example) {
      let xhr = new XMLHttpRequest();
      xhr.open("GET", `/example/${example}.fasta`, false);
      xhr.overrideMimeType("text/html;charset=utf-8");
      xhr.send(null);
      this.seq_text = xhr.responseText;
      this.des_text = "Example";
      this.kingdom_str = "Unknow/Other";
    },

    fastaReset() {
      this.seq_text = "";
      this.kingdom_str = "Unknow/Other";
      this.email_text = "";
      this.des_text = "";
      this.fileList = [];
    },
    fastaSubmit() {
      if (this.seq_text.trim() == "" && this.upload_str == "") {
        this.$alert(
          "Please enter the protein sequence or upload FASTA file",
          "Error",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "Close",
          }
        );
      } else {
        var mission_id = "" + new Date().getTime();
        var post_data = {
          mission_id: mission_id,
          seq_text: this.seq_text,
          kingdom_str: this.kingdom_str,
          des_text: this.des_text,
          email_text: this.email_text,
          upload_str: this.upload_str,
        };
        api.submitMission(post_data).then((res) => {
          console.log(res);
        });
        this.$router.push("/job?id=" + mission_id);
      }
    },
  },

  beforeMount() {},
  mounted() {},
  watch: {},
};
</script>
<style lang="less" scoped>
@color-theme: #409eff;
@bg-theme: #f5f8fd;
@color-theme-hover: #409eff94;
a {
  color: @color-theme !important;
}
.input_example {
  color: @color-theme;
}
.page-title,
.search-color {
  color: @color-theme;
}
/deep/input {
  height: 50px;
  padding-left: 15px;
  font-size: 20px;
  border-radius: 4px;
  outline: none;
}

/deep/.el-button {
  font-size: 22px !important;
  height: 50px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
  border: 2px;
  background: @color-theme;
}

/deep/.el-button:hover,
.el-button:focus {
  background: @color-theme-hover;
}
/deep/.upload-btn {
  font-size: 18px !important;
  border-radius: 4px;
  height: 40px;
  margin-top: 20px;
}
/deep/.div-title {
  background: @color-theme;
}
/deep/.div-content {
  border-top: 0;
}
/deep/.div-unit {
  border: 3px solid @color-theme;
  border-color: @color-theme;
  background-color: @bg-theme;
}
/deep/.el-cascader__dropdown {
  width: 900px !important;
}
</style>
    